/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Lpsma2Inputs */

const en_coinvestments_prospects_lpsma2 = /** @type {(inputs: Coinvestments_Prospects_Lpsma2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LP/SMA`)
};

/**
* | output |
* | --- |
* | "LP/SMA" |
*
* @param {Coinvestments_Prospects_Lpsma2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_lpsma2 = /** @type {((inputs?: Coinvestments_Prospects_Lpsma2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Lpsma2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_lpsma2(inputs)
});
export { coinvestments_prospects_lpsma2 as "coInvestments_prospects_lpSma" }